/**
 * A field worker's POST for a combo the company already has answers 409 with
 * this code and the stored row (api#830). The field may add a combo, never
 * change one. `profile` is the raw `torque_profiles_custom` row, snake_case,
 * and is absent when the combo was created concurrently between the API's
 * check and its insert.
 */
export const TORQUE_PROFILE_EXISTS = 'torque_profile_exists';

export interface ExistingTorqueProfileRow {
  torque_min: number | null;
  torque_optimum: number | null;
  torque_max: number | null;
  torque_low_shoulder: number | null;
  torque_high_shoulder: number | null;
  shouldered: boolean | null;
}

/** The existing row off a `torque_profile_exists` 409, or null for any other error. */
export function torqueProfileExistsOf(err: any): { profile: ExistingTorqueProfileRow | null } | null {
  const body = err?.response?.data;
  if (err?.response?.status !== 409 || body?.code !== TORQUE_PROFILE_EXISTS) return null;
  return { profile: body.profile && typeof body.profile === 'object' ? body.profile : null };
}
